import React from "react";

export default function Panel({ theme, children }) {
  return (
    <div className="px-0 md:px-0">
      <div
        style={{
          borderColor: theme.accent,
          boxShadow: "5px 5px 0px 0px" + theme.accent,
        }}
        className={`p-5 md:p-10 rounded-2xl bg-white border-[2px]`}
      >
        {children}
      </div>
    </div>
  );
}
